export function parseImageUrl(url) {
    if (url) {
        return {
            uid: url,
            status: 'done',
            url: url,
        };
    }
}